
import HorizontalLine from 'Components/Common/components/Button/HorizontalLine';
import { CREATE, MATH, CONDITIONAL, COMPATIBILITY_BY_MATRIX, CBM, LOGIC } from 'Pages/GMS/ISR/ISRConstants';
import { AddIcon } from 'assests/GmsIcons';
import React from 'react';
import { Link } from 'react-router-dom';
import useClickOutside from 'Components/GMS/CustomHooks/useClickOutside';

type TRuleMenuProps = {
    handleOptionClick: Function;
    mergeStates: Function
}

const CreateRuleMenu = (props: React.PropsWithChildren<TRuleMenuProps>) => {
    const { showMenu, ref, handleClick } = useClickOutside();

    return (
        <div ref={ref} className='tw-relative tw-bg-white tw-z-20'>        
            <button onClick={() => { handleClick(); props?.mergeStates() }} className={`tw-rounded ${showMenu ? 'tw-bg-primary tw-text-white' : 'tw-bg-shades-of-grey-0 tw-text-primary'}  tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}>
            <AddIcon color={showMenu ? "#ffffff" : "#0747A6"}  />
            {CREATE}
        </button>
            {showMenu ? (
                <div className={`tw-origin-top-left tw-mt-1 tw-right-0 tw-absolute tw-w-40 tw-mx-3 tw-rounded-[4px] tw-z-50 tw-bg-white tw-ring-1 tw-ring-[#EBECF0]`}>
                    <div className={`tw-py-1`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        <Link to="#" onClick={() => {handleClick(); props.handleOptionClick(MATH)}} className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]`} role="menuitem">{MATH}</Link>
                        <HorizontalLine />
                        <Link to="#" onClick={() => {handleClick(); props.handleOptionClick(CONDITIONAL)}} className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]`} role="menuitem">{CONDITIONAL}</Link>
                        <HorizontalLine />
                        <Link to="#" onClick={() => {handleClick(); props.handleOptionClick(CBM)}} className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]`} role="menuitem">{COMPATIBILITY_BY_MATRIX}</Link>
                        <HorizontalLine />
                        <Link to="#" onClick={() => {handleClick(); props.handleOptionClick(LOGIC)}} className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]`} role="menuitem">{LOGIC}</Link>
                        <HorizontalLine />
                    </div>
                </div>                        
            ) : null}
        </div> 
    );
}

export default CreateRuleMenu;